// 导入封装好的网络请求类工具
import request from './http.js'
// // 7.	根据手机号判断微信端登记的是新增还是修改状态
// export function checkWXPreInputStatus(params) {

//   return request.get("/api/m240/checkWXPreInputStatus",params);
// }

// export function getbaseforminfo(params) {

//   return request.get("/api/baseform/getBaseFormInfo",params);
// }

// 获取创建窗体所有相关信息接口
export function getInfo (params) {
  let { moduleno, userid, langid = 0, flag = 0, mtag = 0 } = params
  return request({
    url: '/api/wx/getBaseFormInfo',
    method: 'get',
    params: { moduleno, userid, langid, flag, mtag }
  })
}
// m201 >>> 策略 >>> 点击左边树后执行的查询操作接口
export function queryGridData (data) {
  const {
    moduleno = 9901,
    userid,
    mviewname,
    fieldlist,
    orderbysql,
    pagequery,
    pagesize,
    pageindex,
    moduleqyfilter,
    specfilter,
    querysql,
    username,
    fastquerylist,
    hasempidfield,
    optionfilter = []
  } = data
  // 获取最近查询的表单数据【所有模块首页的table请求】
  const lastQueryGridData =
    JSON.parse(sessionStorage.getItem('lastQueryGridData')) || {}
  // 记录当前模块查询时的querysql，供导出excel使用
  lastQueryGridData[moduleno] = { querysql }
  // 再存到sessionStorage中
  sessionStorage.setItem('lastQueryGridData', JSON.stringify(lastQueryGridData))
  return request({
    url: '/api/wx/queryGridData',
    method: 'post',
    data: {
      moduleno,
      userid,
      mviewname,
      fieldlist,
      orderbysql,
      pagequery,
      pagesize,
      pageindex,
      moduleqyfilter,
      specfilter,
      querysql,
      username,
      fastquerylist,
      hasempidfield,
      optionfilter
    }
    // headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
// 7.	根据手机号判断微信端登记的是新增还是修改状态
export function checkWXPreInputStatus (params) {
  return request({
    url: '/api/wx/checkWXPreInputStatus',
    method: 'get',
    params: params
  })
}
// 1.	获取有效招聘岗位列表接口
export function getReqStationList (data) {
  return request({
    url: '/api/wx/getReqStationList',
    method: 'get',
    params: data
  })
}
// 7.	根据手机号判断微信端登记的是新增还是修改状态
export function checkWxRsInputStatus (params) {
  return request({
    url: '/api/wx/checkWxRsInputStatus',
    method: 'get',
    params: params
  })
}
// 上传附件
export function upLoadFile (data) {
  const { moduleno, upflag = 1, autoid = 0, uploadpath, username, file } = data
  return request({
    url: '/api/wx/upLoadFile',
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    method: 'post',
    data: { moduleno, upflag, autoid, uploadpath, username, file }
  })
}
export function GetFormFieldDetail (data) {
  // 获取表单控件构造信息
  return request({
    url: '/api/wx/getFormFieldDetail',
    method: 'post',
    data
  })
}
/**
 * 过滤操作：获取选择框的选项
 * 参数： moduleno    模块号
 *        username    当前用户
 *        listsql     下拉sql语句
 *        formjsonstr 当前表单字段
 */
export function GetFilterDropDownList (data) {
  return request({
    url: '/api/wx/getFilterDropDownList',
    method: 'post',
    // data: formFile,
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function GetFormFieldExitValue (data) {
  // 表格数据带出接口
  return request({
    url: '/api/wx/getFormFieldExitValue',
    method: 'post',
    data
  })
}
export function GetFormFieldExitInfo (data) {
  // 退出提示功能
  return request({
    url: '/api/wx/getFormFieldExitInfo',
    method: 'post',
    data
  })
}
// 通用表单 >>> 下拉框 >>> 自定义查询
export function GetCustomQueryInfo (data) {
  return request({
    url: '/api/wx/getCustomQueryInfo',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function GetFormNewDefaultValue (data) {
  return request({
    url: '/api/wx/getFormNewDefaultValue',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
// 通用 >>> 通用表单 根据工号或姓名获取符合条件的人员信息
export function getEmpInfo (data) {
  return request({
    url: '/api/wx/getEmpInfo',
    method: 'get',
    params: data
  })
}
export function GetBeforeActionList (data) {
  // 保存数据接口1//删除1
  return request({
    url: '/api/wx/getBeforeActionList',
    method: 'get',
    params: data
  })
}
export function ProcessBeforeAction (data) {
  // 保存数据接口2//删除2
  return request({
    url: '/api/wx/processBeforeAction',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function PostModuleRecord (data) {
  // 保存数据接口3
  return request({
    url: '/api/wx/postModuleRecord',
    method: 'post',
    data
  })
}
export function ProcessAfterAction (data) {
  // 保存数据接口3
  return request({
    url: '/api/wx/processAfterAction',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function GetFormRecordData (data) {
  // 保存后获取主表记录接口
  return request({
    url: '/api/wx/getFormRecordData',
    method: 'post',
    data
  })
}
export function getmoduleattfilelist (data) {
  // 获取附件信息
  return request({
    url: '/api/wx/getModuleAttFileList',
    method: 'get',
    params: data
  })
}
// m201 >>> 策略 >>> 附件：删除模块附件列表的接口
export function deleteFile (data) {
  const {
    moduleno,
    dflag = 1,
    autoid = 0,
    filename,
    fileext,
    downloadpath
  } = data
  return request({
    url: '/api/wx/deleteFile',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    data: { moduleno, dflag, autoid, filename, fileext, downloadpath }
  })
}
// m201 >>> 策略 >>> 附件：查看模块附件列表的接口
export function getDownLoadFileName (data) {
  const {
    moduleno,
    dflag = 1,
    autoid = 0,
    filename,
    fileext,
    downloadpath
  } = data
  return request({
    url: '/api/wx/getDownLoadFileName',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    data: { moduleno, dflag, autoid, filename, fileext, downloadpath }
  })
}

// 获取token
export function getWxApiToken (data) {
  // 获取附件信息
  return request({
    url: '/api/login/getWxApiToken',
    method: 'get',
    params: data
  })
}
// 240根据身份证号码登录扫码入职
export function checkPreLoginByIdCardNum240 (data) {
  // 获取附件信息
  return request({
    url: '/api/m240/checkPreLoginByIdCardNum',
    method: 'get',
    params: data
  })
}
// 304根据身份证号码登录扫码入职
export function checkPreLoginByIdCardNum304 (data) {
  // 获取附件信息
  return request({
    url: '/api/m304/checkPreLoginByIdCardNum',
    method: 'get',
    params: data
  })
}
// 获取扫码投递岗位对应问卷详细信息接口
export function getQsTemplateOptionList (data) {
  // 获取附件信息
  return request({
    url: '/api/wxzp/getQsTemplateOptionList',
    method: 'get',
    params: data
  })
}
// 保存扫码简历的问卷信息接口
export function saveQsTemplateOptionList (data) {
  // 保存后获取主表记录接口
  return request({
    url: '/api/wxzp/saveQsTemplateOptionList',
    method: 'post',
    data
  })
}

// 通用微信扫码登录判断接口（除240和304模块以外使用）
export function checkWxRsInputStatus_Comm (params) {
  const { iflag, inputcode } = params
  return request({
    url: '/api/wx/checkWxRsInputStatus_Comm',
    method: 'get',
    params: { iflag, inputcode }
  })
}

// 获取通用树结构
export function getCommTreeData (data) {
  return request({
    url: '/api/wx/getCommTreeData',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

// 3.获取短信验证码
export function getSmsCode (params) {
  const { mobilephone } = params
  return request({
    url: '/api/wx/getSmsCode',
    method: 'get',
    params: { mobilephone }
  })
}

// 根据guid判断二维码是否有效接口
export function checkQrCodeGuid (params) {
  const { guid } = params
  return request({
    url: '/api/m240/checkQrCodeGuid',
    method: 'get',
    params: { guid }
  })
}
// 上传base64文件
export function upLoadBase64File (data) {
  return request({
    url: '/api/wx/upLoadBase64File',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    data
  })
}
// 上传base64文件+命名
export function upLoadBase64FileFixName (data) {
  return request({
    url: '/api/wx/upLoadBase64FileFixName',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8;' },
    data
  })
}

// 19.	根据empid获取内部员工简历记录id
export function getLocalEmpInfo (params) {
  const { empid } = params
  return request({
    url: '/api/wx/getLocalEmpInfo',
    method: 'get',
    params: { empid }
  })
}

// 获取是否显示协议参数
export function getUserDataAgreeInfo (params) {
  const { moduleno, username } = params
  return request({
    url: '/api/wx/getUserDataAgreeInfo',
    method: 'get',
    params: { moduleno, username }
  })
}

// 获取扫码投递岗位对应问卷详细信息接口
export function getQsTemplateOptionList_stationid (data) {
  return request({
    url: '/api/wxzp/getQsTemplateOptionList_stationid',
    method: 'get',
    params: data
  })
}

//	微信端获取用户openid接口
export function getOpenId (data) {
  return request({
    url: '/api/wx/getOpenId_Json',
    method: 'get',
    params: data
  })
}
//	根据手机号码绑定openid到人才库
export function bindWxOpenIdByMobilePhone (data) {
  return request({
    url: '/api/wx/bindWxOpenIdByMobilePhone',
    method: 'get',
    params: data
  })
}

// // 点击下一步或上一步（或左边切换）时保存数据接口
export function saveRsTempRecord (data) {
  return request({
    url: '/api/wx/saveRsTempRecord',
    method: 'post',
    data
  })
}


//  删除子表记录
export function deleteRecord (data) {
  return request({
    url: '/api/baseform/deleteRecord',
    method: 'post',
    data
  })
}

//  OCR识别身份证正面图片信息
export function getIdCardFrontInfo (data) {
  return request({
    url: '/api/wx/getIdCardFrontInfo',
    method: 'post',
    data
  })
}

//  OCR识别身份证反面图片信息
export function getIdCardBackInfo (data) {
  return request({
    url: '/api/wx/getIdCardBackInfo',
    method: 'post',
    data
  })
}

//	扫码入职登陆前的判断接口
export function checkScanEntryBeforeLogin (data) {
  return request({
    url: '/api/wx/checkScanEntryBeforeLogin',
    method: 'get',
    params: data
  })
}
